import { zoom, zoomIdentity } from 'd3-zoom';
import { tree, hierarchy } from 'd3-hierarchy';
import { select, selectAll, event } from 'd3-selection';
import { max } from "d3-array";

export default {
  zoom: zoom,
  zoomIdentity: zoomIdentity,
  tree: tree,
  hierarchy: hierarchy,
  select: select,
  selectAll: selectAll,
  max: max,
  get event() { return event; }
};



// WEBPACK FOOTER //
// ./client/app/components/pyramid-builder/d3-custom.js